module.exports = __webpack_public_path__ + "img/arrow_right.03a63f65.svg";